import { Column, Row } from '@unistocks/components/layout/flex';
import { Breadcrumbs } from '@unistocks/components/navigation/breadcrumbs';
import { PageHeading } from '@unistocks/components/page/header/heading/page-heading';
import { PageHeaderProps } from '@unistocks/components/page/header/types';
import React from 'react';
import { View } from 'tamagui';

export const PageHeader: React.FC<PageHeaderProps> = ({
  scrollOffset,
  showBackArrow = true,
  showNotificationIcon,
  logo,
  onLogoPress,
  title,
  subtitle,
  icon,
  breadcrumbs
}) => {
  const renderTitle = () => {
    if (typeof title === 'string') {
      return <PageHeading>{title}</PageHeading>;
    } else if (React.isValidElement(title)) {
      return title;
    }

    // If there is no title, return invisible text to keep the layout consistent. Avoid rendering H1 tag when not used
    return (
      <PageHeading render={'div'} o={0}>
        {'_'}
      </PageHeading>
    );
  };

  /* const renderSubtitle = () => {
    if (!subtitle) return null;

    return typeof subtitle === 'string' ? (
      <PageHeading o={SUBTITLE_OPACITY}>{subtitle}</PageHeading>
    ) : (
      subtitle
    );
  }; */

  return (
    <Row alignItems="center" justifyContent="space-between" py={'$2'}>
      <Column>
        {/* {canGoBack ? <HeaderButton Icon={ArrowLeft} onPress={router.back} /> : null} */}
        <View mr={'auto'}>{renderTitle()}</View>
        {breadcrumbs?.length ? <Breadcrumbs routes={breadcrumbs} /> : null}
      </Column>
      {icon}
    </Row>
  );
};
